import { GetSupplierProductByMainNo, GetProductInfoByTracNo,SendUdiResolverConfirm } from "@/api";

export default {
  name: "ScanMixin",
  data () {
    return {
      // 扫码框焦点
      scanInputIsfocus: false,
      // 是否扫码界面
      showCode: false,
      // 扫码次数
      count: 0,
      // 扫到的码
      code: "",
      // 上次时间
      lastTime: 0,

      tableCode: "",

      showWarning: true,
      checkboxConfirmed: false,

      originalData:[],
      options: [],
      selectedOptions: 0,
      isMultipleResults: false,
      checkboxRadioStates:[]
    };
  },
  mounted () {
    this.tableCode = this.$route.name.replace("Edit", "");
    window.addEventListener("keypress", this.init, true);
  },
  destroyed () {
    window.removeEventListener("keypress", this.init, true);
  },

  methods: {
    updateShowWarning () {
      this.showWarning = true;
      this.checkboxConfirmed = false
    },
    pushChildForm (close) {
      let result = true;
      this.$refs["childForm"].validate((valid) => {
        result = valid;
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        let fn1 = () => {
          
          if (this.childForm.mainNo && this.childForm.traceNo) {
            var childForm = this.childForm;
            // 添加行
            let arr = this.form.details.filter(
              (item) =>
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo &&
                item.manufactureDate == childForm.manufactureDate &&
                item.batch == childForm.batch &&
                item.validityDate == childForm.validityDate &&
                item.serialNo == childForm.serialNo &&
                item.longTime == childForm.longTime &&
                item.price == childForm.price
            );

            // 添加行记录
            if (arr.length > 0) {
              // 存在则把列表的数据拿过来，并且数量加1
              this.form.details = this.form.details.map((item) => {
                if (
                  item.mainNo == childForm.mainNo &&
                  item.traceNo == childForm.traceNo &&
                  item.manufactureDate == childForm.manufactureDate &&
                  item.batch == childForm.batch &&
                  item.validityDate == childForm.validityDate &&
                  item.serialNo == childForm.serialNo &&
                  item.longTime == childForm.longTime &&
                  item.price == childForm.price
                ) {
                  item.packSpec = childForm.packSpec;
                  item.locationId = childForm.locationId;
                  item.locationName = childForm.locationName;
                  item.manufactureDate = childForm.manufactureDate;
                  item.batch = childForm.batch;
                  item.validityDate = childForm.validityDate;
                  item.serialNo = childForm.serialNo;
                  item.remark = childForm.remark;
                  item.number = childForm.number;
                  item.unUseNumber = childForm.unUseNumber;
                  item.price = childForm.price;
                  item.amount = childForm.amount;
                }
                return item;
              });
            } else {
              // 不存在则添加行记录
              var childForm = JSON.parse(JSON.stringify(this.childForm));
              childForm.$index = this.form.details.length + 1;
              this.form.details.push(childForm);
            }
          } else {
            if (this.editChildren) {
              let item = this.form.details.find(
                (e) => e.$index == this.childForm.$index
              );
              Object.assign(item, this.childForm);
            } else {
         
              this.form.details.push(this.childForm);
            }
          }

          this.autoTotalAmount();
          this.resetDetailFormData();
          if (close) {
            // console.log("fn()7")
            this.openSubformModal = false;
            this.count = 0;
            this.isScan = false;
            this.checkboxConfirmed = false
          }
        };


        let fn2 = () => {
          if (this.childForm.mainNo && this.childForm.traceNo) {
            var childForm = this.childForm;
            // 添加行
            let arr = this.form.details.filter(
              (item) =>
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo &&
                item.manufactureDate == childForm.manufactureDate &&
                item.batch == childForm.batch &&
                item.validityDate == childForm.validityDate &&
                item.serialNo == childForm.serialNo &&
                item.longTime == childForm.longTime &&
                item.price == childForm.price
            );
            
            let item = this.form.details.find(
              (e) =>
                e.$index != this.childForm.$index &&
                e.supplierProductId == this.childForm.supplierProductId //&&
              // e.price == this.childForm.price &&
              // e.locationName == this.childForm.locationName &&
              // e.assetSource == this.childForm.assetSource &&
              // e.packDesc == this.childForm.packDesc &&
              // e.manufacturerId == this.childForm.manufacturerId &&
              // e.certId == this.childForm.certId &&
              // e.brandId == this.childForm.brandId
            );


            if (item && !this.editChildren) {
              // 新增有重复项提示
              // Object.assign(item, this.childForm);
              this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
              return;
            } else if (item && this.editChildren) {
              // 编辑且有重复项
              this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
              return;
            }

            // 添加行记录
            if (arr.length > 0) {
              
              // console.log("fn()2")
              // 存在则把列表的数据拿过来，并且数量加1
              this.form.details = this.form.details.map((item) => {
                if (
                  item.mainNo == childForm.mainNo &&
                  item.traceNo == childForm.traceNo &&
                  item.manufactureDate == childForm.manufactureDate &&
                  item.batch == childForm.batch &&
                  item.validityDate == childForm.validityDate &&
                  item.serialNo == childForm.serialNo &&
                  item.longTime == childForm.longTime &&
                  item.price == childForm.price
                ) {
                  // console.log("fn()3")
                  item.packSpec = childForm.packSpec;
                  item.locationId = childForm.locationId;
                  item.locationName = childForm.locationName;
                  item.manufactureDate = childForm.manufactureDate;
                  item.batch = childForm.batch;
                  item.validityDate = childForm.validityDate;
                  item.serialNo = childForm.serialNo;
                  item.remark = childForm.remark;
                  item.number = childForm.number;
                  item.unUseNumber = childForm.unUseNumber;
                  item.price = childForm.price;
                  item.amount = childForm.amount;
                }
                return item;
              });
            } else {
              // 不存在则添加行记录
              var childForm = JSON.parse(JSON.stringify(this.childForm));
              childForm.$index = this.form.details.length + 1;
              this.form.details.push(childForm);
            }
          }

          else if ( this.editChildren) {
            // 编辑
            item = this.form.details.find((e) => e.$index == this.childForm.$index);
            Object.assign(item, this.childForm);
          } else {
            this.form.details.push(this.childForm);
          }

          this.autoTotalAmount();
          this.resetDetailFormData();
          if (close) {
            this.openSubformModal = false;
            this.count = 0;
            this.isScan = false;
            this.checkboxConfirmed = false
          }
        }


        let emptyArr = [];
        // console.log("showWarning:",this.showWarning)
        if (!this.childForm.batch) {
          emptyArr.push("[批次号]");
        }
        if (!this.childForm.manufactureDate) {
          emptyArr.push("[生产日期]");
        }
        if (!this.childForm.validityDate && this.childForm.longTime != 1) {
          emptyArr.push("[有效期]");
        }

        if (
          emptyArr &&
          emptyArr.length > 0 &&
          this.showWarning &&
          this.childForm.mainNo &&
          !this.checkboxConfirmed
        ) {
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            message: `${emptyArr.join("、")}未填写，是否继续?`,
          })
            .then(() => {
              if (this.tableCode != 'StockUpFirstCheck') {
                
                fn1();
              }
              if (this.tableCode == 'StockUpFirstCheck') {
                fn2();
              }
            })
            .catch((e) => {
              this.showWarning = false;
            });
        } else {
          if (this.tableCode != 'StockUpFirstCheck') {
            fn1();
          }
          if (this.tableCode == 'StockUpFirstCheck') {
            fn2();
          }
        }
      });
      return result;
    },

    // 扫码相关
    init (e) {
      this.showWarning = false;
      // console.log("1",this.showWarning)
      var currCode = e.which;
      var currTime = new Date().getTime();
      if (this.lastTime > 0) {
        if (currTime - this.lastTime <= 100) {
          // this.code += String.fromCharCode(currCode);
        } else {
          // if (currTime - this.lastTime > 1000) {
          // 超时清空
          this.clearCode();
        }
        this.code += String.fromCharCode(currCode);
      }
      // 第一次按键
      else {
        this.code = String.fromCharCode(currCode);
      }
      this.lastTime = currTime;
      
      // 遇到回车
      if (currCode == 13 && this.isScan && !this.scanInputIsfocus) {
        
        this.showWarning = false;
        // alert(code); // 这里得到码，做下一步业务处理
        
        if (
          !this.childForm.batch ||
          !this.childForm.manufactureDate ||
          (!this.childForm.validityDate && this.childForm.longTime != 1)
        ) {
          if (this.childForm.mainNo && this.childForm.traceNo && !this.checkboxConfirmed) {
            
            this.showWarning = true;
            let emptyArr = [];
            if (!this.childForm.batch) {
              emptyArr.push("[批次号]");
            }
            if (!this.childForm.manufactureDate) {
              emptyArr.push("[生产日期]");
            }           
            console.log(this.childForm.validityDate);
             
            if (!this.childForm.validityDate && this.childForm.longTime != 1) {
              emptyArr.push("[有效期]");
            }
            if (
              emptyArr &&
              emptyArr.length > 0 &&
              this.childForm.mainNo !== this.code &&
              this.showWarning
            ) {
              this.options = []
              this.showWarning = false;
              this.$confirm("提示", {
                title: "提示",
                type: "warning",
                message: `${emptyArr.join("、")}未填写，是否继续?`,
              })
                .then(() => {

                  this.count = 0;
                  this.mainNoChange(this.code);
                  // 回车输入后清空
                  this.clearCode()
                  this.$nextTick(() => {
                    const dialogFooter = document.querySelector(".el-message-box__btns");
                    if (dialogFooter) {
                        const existingSpan = dialogFooter.querySelector(".custom-span");
                        if (existingSpan) {
                            existingSpan.remove();
                        }
                    }
                    // this.checkboxConfirmed = this.checkbox.checked
                    console.log("checked", this.checkboxConfirmed)
                  })
                })

                .catch((e) => {
                  // console.log("取消",e)
                  this.checkboxConfirmed = false
                  this.$nextTick(() => {
                    const dialogFooter = document.querySelector(".el-message-box__btns");
                    if (dialogFooter) {
                        const existingSpan = dialogFooter.querySelector(".custom-span");
                        if (existingSpan) {
                            existingSpan.remove();
                        }
                    }
                });
                });




              // 使用 nextTick 确保 DOM 已更新
              this.$nextTick(() => {
                // 查找弹出框的按钮行
                const dialogFooter = document.querySelector(
                  ".el-message-box__btns"
                );
                if (dialogFooter) {
                  // 检查是否已经存在 .custom-span
                  const existingSpan = dialogFooter.querySelector(".custom-span");
                  if (!existingSpan) {
                    // 创建 span 元素并添加 class
                    const span = document.createElement("span");
                    span.className = "custom-span"; // 添加类名
                    span.style.display = "inline-flex";
                    span.style.alignItems = "center";

                    // 创建 input[type="checkbox"] 元素并添加 class
                    const checkbox = document.createElement("input");
                    checkbox.type = "checkbox";
                    checkbox.className = "custom-checkbox"; // 添加类名
                    checkbox.style.marginRight = "5px"; // 给复选框和文本之间留一些空间



                    checkbox.checked = true;
                    this.checkboxConfirmed = checkbox.checked
                    console.log("check", checkbox.checked)
                    // 创建文本节点
                    const text = document.createTextNode("本次连续扫码不再提示");

                    // 将复选框和文本添加到 span 中
                    span.appendChild(checkbox);
                    span.appendChild(text);

                    // 将 span 插入到按钮行的最前面
                    dialogFooter.insertBefore(span, dialogFooter.firstChild);

                    // 添加点击事件监听器
                    checkbox.addEventListener("click", (event) => {
                      this.checkboxConfirmed = event.target.checked;
                      this.checkboxConfirmed = checkbox.checked
                      console.log("checkboxConfirmed", this.checkboxConfirmed)
                    });
                  } else {
                    // 如果已存在，则直接获取复选框元素
                    const checkbox = existingSpan.querySelector(".custom-checkbox");
                    checkbox.checked = true
                    checkbox.addEventListener("click", (event) => {
                      this.checkboxConfirmed = event.target.checked;
                      this.checkboxConfirmed = checkbox.checked
                      console.log("checkboxConfirmed", this.checkboxConfirmed)
                    });
                    console.log("已存在，则直接获取复选框元素", this.checkboxConfirmed)
                    if (checkbox) {
                      this.checkboxConfirmed = checkbox.checked;
                    }
                  }
                }
              });
              // // 延迟执行 fn() 以确保复选框状态已更新


            } else {
              // console.log("啊？")
            }
          } else {
            // console.log("b")
            this.showWarning = false;
            this.mainNoChange(this.code);
            // 回车输入后清空
            this.clearCode();
          }
        } else {
          // console.log("a")
          this.count = 0;
          this.mainNoChange(this.code);
          // 回车输入后清空
          this.clearCode();
        }
      }
    },
    clearCode () {
      this.code = "";
      this.lastTime = 0;
    },
    mainNoChange (val, num) {
      // 去掉空格
      val = val.replace(/\s+/g, "").toUpperCase();
      if (!val || val == "") {
        return;
      }

      if (this.count === 0) {
        if (this.childForm.mainNo && this.childForm.traceNo) {
          let valid = this.pushChildForm(false);

          if (!valid) {
            this.code = "";
            this.childForm.no = "";
            return;
          }
        }
        this.getSupplierProductByMainno(val, num);
      } else {
        if (val == this.childForm.mainNo) {
          this.$my_message("主码和追溯码不能相同", "warning");
          return;
        }
        var traceNo = val;
        if (this.childForm.mainNo) {
          // console.log("mainNoChange-1")
          traceNo = val.startsWith(this.childForm.mainNo)
            ? val.substr(
              this.childForm.mainNo.length,
              val.length - this.childForm.mainNo.length
            )
            : val;
        }
        this.getSupplierByTraceNo(traceNo);
      }
    },
    getSupplierProductByMainno (no, num) {
      // var isEnabledStr = num == 1 ? num : "0";
      var isEnabledStr = '1'
      var reg = RegExp(`^${this.childForm.mainNo}`);
      if (
        no == this.childForm.mainNo ||
        (reg.exec(no) && this.childForm.mainNo && this.childForm.mainNo != "")
      ) {
        this.count++;
        this.childForm.no = "";
        return;
      }
      this.resetDetailFormData();
      GetSupplierProductByMainNo({
        mainNo: no,
        isEnabledStr: isEnabledStr,
      }).then((res) => {
        if (!res.successful) {
          return;
        }

        if (
          (this.tableCode == "PurchaseDistribution" ||
            this.tableCode == "StockUpCheck" ||
            this.tableCode == "SurgicalCheck") &&
          res.returnData.isEnabled != 1
        ) {
          this.$my_message(
            `产品名称 [${res.returnData.productName}] 规格型号 [${res.returnData.specName}] 已被禁用，请核对后再验收`,
            "warning"
          ); //
          return;
        }

        // this.childForm = this.mapper.SupplierProduct2Form(this.childForm, res.returnData)
        let id = this.childForm.id;
        this.childForm = Object.assign(this.childForm, res.returnData);
        this.childForm.id = id;
        this.childForm.remark = "";
        this.childForm.supplierProductId = res.returnData.id;
        this.childForm.supplierProductNo = res.returnData.no;
        this.childForm.packNumber = res.returnData.packNumber
          ? res.returnData.packNumber
          : 0;
        // this.childForm.number = 1
        this.childForm.price = this.childForm.purchasePrice;
        // this.childForm.amount = this.childForm.price
        this.childForm.no = "";
        this.childForm.mainNo = this.childForm.countryNo;

        this.childForm.number = 1;
        this.childForm.unUseNumber = 1;
        if (this.tableCode == "CollectInStock") {
          this.childForm.price = res.returnData.billingPrice;
          this.childForm.purchasePrice = res.returnData.purchasePrice;
          this.childForm.purchaseAmount = res.returnData.purchasePrice;
        }

        this.getProductRegistCertDetails(this.childForm.productId);

        this.childForm.amount = this.childForm.number * this.childForm.price;
        this.count++;
        this.childForm.no = "";
        this.$forceUpdate();
      });
    },
    getSupplierByTraceNo (no) {
      // console.log("getSupplierByTraceNo")
      if (this.childForm.traceNo == no && this.childForm.number > 0) {
        // console.log("getSupplierByTraceNo1")
        this.childForm.number = this.childForm.number * 1 + 1;
        this.childForm.unUseNumber = this.childForm.number;
        this.childForm.amount = this.childForm.number * this.childForm.price;
        this.count--;
        this.childForm.no = "";
        return;
      }

      //添加行
      let arr = this.form.details.filter(
        (item) => item.mainNo == this.childForm.mainNo && item.traceNo == no
      );
      this.childForm.traceNo = no;

      // 添加行记录
      if (arr.length > 0) {
        // console.log("getSupplierByTraceNo2")
        // 存在则把列表的数据拿过来，并且数量加1
        this.editChildren = true;
        this.form.details = this.form.details.map((item) => {
          if (item.mainNo == this.childForm.mainNo && item.traceNo == no) {
            // console.log("getSupplierByTraceNo2-1")
            this.childForm.packSpec = item.packSpec;
            this.childForm.locationId = item.locationId;
            this.childForm.locationName = item.locationName;
            this.childForm.manufactureDate = item.manufactureDate;
            this.childForm.batch = item.batch;
            this.childForm.validityDate = item.validityDate;
            this.childForm.serialNo = item.serialNo;
            this.childForm.remark = item.remark;
            this.childForm.number = item.number * 1 + 1;
            this.childForm.unUseNumber = this.childForm.number;
            this.childForm.price = item.price;
            this.childForm.billingPrice = item.billingPrice;
            this.childForm.purchasePrice = item.purchasePrice;
            this.childForm.amount =
              this.childForm.number * this.childForm.price;
            this.childForm.purchaseAmount =
              this.childForm.number * this.childForm.purchasePrice;
              this.childForm.orgCode = sessionStorage.getItem('orgId')
          }
          return item;
        });

        this.count--;
        this.childForm.no = "";
      } else {
        // console.log("getSupplierByTraceNo3")
        // 不存在则调用扫码解析，解析成功添加行记录
        GetProductInfoByTracNo({
          traceNo: no,
          mainNo: this.childForm.mainNo,
        }).then((res) => {
          if (!res.successful) {
            return;
          }
          this.originalData = res.returnData 
          this.options = this.originalData
          this.options.push({ NoMorePrompts: true })
          this.showConfirmDialog()
          // this.count--;
          // this.childForm.no = "";
          // this.childForm.$index = this.form.details.length + 1;
          // this.childForm.manufactureDate = res.returnData.manufactureDate;
          // this.childForm.batch = res.returnData.batch;
          // this.childForm.validityDate = res.returnData.validityDate;
          // this.childForm.serialNo = res.returnData.serialNo;
          // this.childForm.number = 1;
          // this.childForm.unUseNumber = this.childForm.number;
          // this.childForm.amount = this.childForm.number * this.childForm.price;
          // this.childForm.purchaseAmount =
          // this.childForm.number * this.childForm.purchasePrice;
          // this.$forceUpdate();
        });

      }
    },
    async childFormAssignment () {
      let data = this.originalData[this.selectedOptions]
      console.log(data);
      this.childForm.orgCode = sessionStorage.getItem('orgId')
      this.count--;
      this.childForm.no = "";
      this.childForm.$index = this.form.details.length + 1;
      this.childForm.manufactureDate = data.manufactureDate;
      this.childForm.batch = data.batch;
      this.childForm.validityDate = data.validityDate;
      this.childForm.serialNo = data.serialNo;
      this.childForm.number = 1;
      this.childForm.unUseNumber = this.childForm.number;
      this.childForm.amount = this.childForm.number * this.childForm.price;
      this.childForm.purchaseAmount =
      this.childForm.number * this.childForm.purchasePrice;
      this.selectedOptions = 0
      if( this.originalData.length>1){
       await SendUdiResolverConfirm({
          mainNo: this.childForm.mainNo,
          traceNo: this.childForm.traceNo,
          batchLength:this.childForm.batch?this.childForm.batch.length:0,
          serialNoLength:this.childForm.serialNo?this.childForm.serialNo.length:0,
          count:1
        })
      }
      this.$forceUpdate();
    },


    // 处理渲染
    createCheckbox (option) {
      const isCheckbox = option.index == this.options.length-1; 
      return this.$createElement('div', { class: 'custom-span' }, [
        this.$createElement('input', {
          attrs: {
            type: isCheckbox ? 'checkbox' : 'radio',  // 判断是复选框还是单选框
            class: 'custom-checkbox',
            name: isCheckbox ? `checkbox_${option.index}` : 'radio_group', // 每个复选框使用不同的name, 单选框共享 name
            checked: option.checked || false
          },
          on: {
            change: (event) =>{
              this.checkboxRadioStates[option.index] = event.target.checked;
                    option.checked = event.target.checked;

              this.handleCheckboxChange(event, option.index)
            }
          }
        }),
        this.$createElement('span', option.name)
      ]);
    },



    showConfirmDialog () {
      if (this.isMultipleResults||this.options.length == 2) {
        this.childFormAssignment()
      } else {        
        const messageVNode = this.$createElement('div', {key: Date.now()}, [
          this.$createElement('p', `追溯码解码结果存在多个，请选择正确的结果`),
  
          this.$createElement('div', { class: 'checkbox-container' },
              this.options.map((item, index) => {
              let obj = {}
              // 生成字段的拼接
              let nameParts = [];
              if (item.batch) {
                nameParts.push(`批次号 ${item.batch}`);
              }
              if (item.serialNo) {
                nameParts.push(`序列号 ${item.serialNo}`);
              }
              if (item.manufactureDate) {
                nameParts.push(`生产日期 ${item.manufactureDate}`);
              }
              if (item.validityDate) {
                nameParts.push(`失效日期 ${item.validityDate}`);
              }
           
              if(index==0){
                obj.checked = true
              }else{
                obj.checked = false
              }
              if (item.NoMorePrompts) {
                nameParts.push(`下次不再弹窗提醒`);
                obj.checked = true
                this.isMultipleResults = true; 
              }

              // 将拼接的部分以中文逗号分隔
              obj.name = nameParts.join('，');
              obj.index = index
              
              return this.createCheckbox(obj)
            })
          
          )
        ]);
        
          this.$msgbox({
            title: '提示',
            message: messageVNode,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.childFormAssignment()
            this.options = []
            // 重置选中状态数组
            this.checkboxRadioStates = [];
          }).catch(() => {
            this.isMultipleResults = false;
            this.selectedOptions = '';
            this.options = [];
            // 同样重置选中状态数组
            this.checkboxRadioStates = [];
          });
          this.$nextTick(() => {
          
            const existingSpan = document.querySelector(".custom-span");
            console.log(existingSpan);
            
            if (!existingSpan) {
              existingSpan.remove()
            }
          })
          this.$forceUpdate()
      }
    },
    handleCheckboxChange (event, index) {
      if (index == this.options.length-1) {
        this.isMultipleResults = event.target.checked
        // this.selectedOptions = 0
      } else {
        this.selectedOptions = index
      }
      // // this.selectedOptions[index] = event.target.checked;
    },
    scanInputFocus () {
      this.scanInputIsfocus = true;
    },
    scanInputBlur () {
      this.scanInputIsfocus = false;
    },


  },
};
